exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "footer[_v-0c4f3e24]{float:left;display:block;margin-top:100px;width:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-0c4f3e24&scoped=true!./~/vue-loader/lib/selector.js?type=style&index=0!./src/layout/rodape/footer.vue
// module id = 165
// module chunks = 0